// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__V8Lu+","content":"Footer_content__rw0cu"};